import { fork, all } from 'redux-saga/effects';
import routeSaga from '../modules/routing/sagas.js';
import appSaga from '../modules/app/sagas.js';
import authSaga from '../modules/auth/sagas.js';
import notificationSaga from '../modules/notification/sagas.js';
import socketSaga from '../modules/socket/saga.js';
import fcmSaga from '../modules/fcm/sagas.js';
import userNotificationsSaga from '../modules/userNotifications/sagas.js';
import merchandiseSaga from '../modules/merchandise/saga.js';
// import checkPageAccess from '../modules/checkPageAccess/sagas.js';
// import fetchPackage from '../modules/package/sagas.js';

export default function* sagas() {
  yield all([
    fork(routeSaga),
    fork(appSaga),
    fork(authSaga),
    fork(notificationSaga),
    fork(socketSaga),
    fork(fcmSaga),
    fork(userNotificationsSaga),
    fork(merchandiseSaga),
    // fork(checkPageAccess),
    // fork(fetchPackage),
  ]);
}
